import React from 'react';
import { Activities } from '../components';
import { useNavigate } from "react-router-dom";
import { withRouter } from 'us.common/wIthRouter';

interface ICnt_Activities {

}


const Cnt_Activities = (props: ICnt_Activities) => {
    const navigate = useNavigate();
    const onMinimize = () => {
        navigate('')
    }

    return (
        <Activities.Home onMinimize={onMinimize} />
    )
}

export default withRouter(Cnt_Activities);